angular.module('services.editionResource', ['security.service']).factory('editionResource', ['$http', '$q', '$log', 'security', function ($http, $q, $log, security) {
  // local variable
  var baseUrl = '/api';
  var processResponse = function(res){
    return res.data;
  };
  var processError = function(e){
    var msg = [];
    if(e.status)         { msg.push(e.status); }
    if(e.statusText)     { msg.push(e.statusText); }
    if(msg.length === 0) { msg.push('Unknown Server Error'); }
    return $q.reject(msg.join(' '));
  };
  // public api
  var resource = {};
  resource.getEdition = function(data){
    return $http.post(baseUrl + '/sendMessage', data).then(processResponse, processError);
  };
  resource.addEdition = function(edition){
    return $http.put(baseUrl + '/account/settings/addEdition', edition).then(processResponse, processError);
  };

  return resource;
}]);



// WEBPACK FOOTER //
// ./client/src/common/services/editionResource.js